import { isMacOs } from '@jira/platform__os-detection/src/isMacOs.tsx';

export const getShortcutModifierKey = () => (isMacOs() ? 'meta' : 'ctrl');
